<template>
  <div>
    <!-- Modal de permissões da câmera -->
    <div v-if="!cameraPermissionGranted" class="camera-modal">
      <div class="camera-modal-content">
        <button class="close-button" @click="closeCameraModal">
          <i class="fa fa-times close-icon"></i>
        </button>
        <div class="camera-modal-header">
          <span>Para entrar na aula, é necessário registrar sua presença.</span>
          <p>Habilite as permissões do navegador para registrar a presença.</p>
        </div>

        <img class="col-12" id="avatar-hora" src="~assets/permitirCamera.png" />

        <button v-if="loading" class="col-12 camera-modal-button" disabled>
          <div class="d-flex justify-content-center">
            <div role="toolbar" aria-label="Toolbar with button groups">
              <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="24"></component>
            </div>
          </div>
        </button>

        <button v-else class="col-12 camera-modal-button" @click="requestCameraPermission">
          Permitir câmera
          <i class="fa fa-arrow-right"></i>
        </button>
      </div>
    </div>

    <!-- Modal de tirar foto -->
    <div v-else-if="showTakePhotoModal" class="camera-modal">
      <div class="camera-modal-content">
        <button class="close-button" @click="closeCameraModal">
          <i class="fa fa-times close-icon"></i>
        </button>

        <div class="camera-modal-header">
          <span>Para entrar na aula, é necessário registrar sua presença.</span>
          <p>Verifique que sua foto estará visível.</p>
        </div>

        <div class="col-12">
          <video ref="camera" autoplay></video>
        </div>

        <button v-if="loading" class="col-12 camera-modal-button" disabled>
          <div class="d-flex justify-content-center">
            <div role="toolbar" aria-label="Toolbar with button groups">
              <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="24"></component>
            </div>
          </div>
        </button>

        <button v-else class="col-12 camera-modal-button" @click="takePhoto">
          Tirar foto
          <i class="fa fa-arrow-right"></i>
        </button>

      </div>
    </div>

    <!-- Modal para Exibir a Foto Tirada -->
    <div v-else-if="showPreviewModal" class="camera-modal">
      <div class="camera-modal-content">
        <button class="close-button" @click="closePreviewModal">
          <i class="fa fa-times close-icon"></i>
        </button>
        <div class="camera-modal-header">
          <span>Foto Capturada</span>
        </div>
        <div class="col-12">
          <img :src="capturedImage" alt="Foto Capturada" />
        </div>
        <button class="col-12 camera-modal-button" @click="registerFrequency">Salvar</button>
      </div>
    </div>

    <!-- Modal de erro -->
    <div v-if="showErrorModal" class="camera-modal">
      <div class="camera-modal-content">
        <button class="close-button" @click="closeCameraModal">
          <i class="fa fa-times close-icon"></i>
        </button>
        <div class="camera-modal-header">
          <span>Não foi possível detectar uma câmera em seu dispositivo.</span>
          <p>Permita o uso da câmera ou conecte uma câmera e tente novamente.</p>
        </div>

        <img class="col-12" id="avatar-hora" src="~assets/tentarNovamente.png" />

        <button class="col-12 camera-modal-button" @click="tentarNovamente">
          Tentar novamente
          <i class="fa fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import urlApi from '../../../router/urlApi'
import router from '../../../router'
import * as spinners from 'epic-spinners'

export default {
  props: {
    agrupamento: Object,
  },
  components: {
    ...spinners,
  },
  data () {
    return {
      cameraPermissionGranted: false,
      showTakePhotoModal: false,
      capturedImage: null,
      mediaStream: null,
      showPreviewModal: false,
      showErrorModal: false,
      errorMessage: '',
      loading: false
    }
  },
  methods: {
    openPreviewModal () {
      this.showPreviewModal = true
    },

    closePreviewModal () {
      this.showPreviewModal = false
      this.$emit('close-modal')
    },

    closeCameraModal () {
      this.$emit('close-modal')
    },

    async requestCameraPermission () {
      this.loading = true
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        try {
          this.mediaStream = await navigator.mediaDevices.getUserMedia({ video: true })
          this.cameraPermissionGranted = true
          this.showTakePhotoModal = true
          this.loading = false

          // Adiando a configuração do srcObject até que o elemento video esteja disponível
          this.$nextTick(() => {
            if (this.$refs.camera) {
              this.$refs.camera.srcObject = this.mediaStream
            } else {
            }
          })
        } catch (error) {
          this.showTakePhotoModal = false
          this.showErrorModal = true
          this.errorMessage = 'Erro ao acessar a câmera. Por favor, verifique suas configurações e tente novamente.'
          this.loading = false
        }
      } else {
        this.showErrorModal = true
        this.errorMessage = 'Seu navegador não suporta a API de mídia. Por favor, tente em um navegador diferente.'
        this.showTakePhotoModal = false
        this.loading = false
      }
    },

    takePhoto () {
      if (this.mediaStream) {
        const canvas = document.createElement('canvas')
        const video = this.$refs.camera
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        const context = canvas.getContext('2d')
        context.drawImage(video, 0, 0, canvas.width, canvas.height)

        this.mediaStream.getTracks().forEach((track) => track.stop())

        // Converta a imagem para um formato base64
        this.capturedImage = canvas.toDataURL('image/jpeg')

        // Exibir o modal de visualização
        this.openPreviewModal()
        this.showTakePhotoModal = false
      } else {
      }
    },
    tentarNovamente () {
      this.cameraPermissionGranted = false
      this.showTakePhotoModal = false
      this.capturedImage = null
      this.showErrorModal = false
    },
    join (agrupamento) {
      console.log('aq')
      let instrutor = this.id_role === '3'
      let data = {
        sala: agrupamento.agrupamento, instrutor: instrutor, nome: localStorage.nome, id_aluno: localStorage.id, turma_teorica: agrupamento.id_turma_teorica
      }
      this.$http.post(urlApi + '/ead/meet', data)
        .then(response => {
          window.sessionStorage['agrupamento'] = JSON.stringify(agrupamento)
          window.sessionStorage['intervalo'] = false
          window.sessionStorage['saida'] = false
          let link = response.body.link
          // 'localhost:8081/ead/23er34tqw4ta4wta4traag4a'.substring('localhost:8081/ead/23er34tqw4ta4wta4traag4a'.indexOf("ead") + 1)
          // router.push({ path: '/ead/' + link.substring(link.indexOf('ead') + 1) })
          // window.location.href = response.body.link
          router.push({ path: '/ead/' + btoa(btoa(response.body.link)) })
          this.loadBtnParticipate = false
        })
        .catch(() => {
          this.loadBtnParticipate = false
        })
    },
    registerFrequency () {
      if (this.photo === '') {
        this.$toasted.show('Foto necessária para presença!', {
          position: 'top-right',
        })
        return
      }
      console.log(this.agrupamento)
      // fim
      let data = {
        entidade: 'ALUNO',
        id: localStorage.id,
        turma: this.agrupamento.id_turma_teorica,
        dispositivo: 'navegador'
      }
      this.$http.post(urlApi + '/ead/presenca/novo', data)
        .then(response => {
          this.join(this.agrupamento)
        }).catch(error => {
          this.$toasted.show(error.body.mensagem, {
            position: 'top-right',
            duration: 5000
          })
          this.setFrequency = true
        })
    },

  },
}
</script>

<style scoped>
.camera-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.camera-modal-content {
  max-width: 31.25rem;
  width: 100%;
  padding: 1.5rem 1rem;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  justify-content: center;

  background: #fff;
  border-radius: 5px;
  position: relative;
}

.camera-modal-header {
  max-width: 27rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.camera-modal-header>span {
  color: #0F0E0E;
  font-size: 1.5rem;
  font-weight: 700;
}

.camera-modal-header>p {
  color: #0F0E0E;
  font-size: 1rem;
  font-weight: 600;
}

.camera-modal-button {
  padding: 1.5rem 0.75rem;
  border: 0;
  border-radius: 4px;
  background: #FABF10;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  color: #0F0E0E;
  font-size: 1rem;
  font-weight: 700;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: white;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1;
}

.close-icon {
  font-size: 20px;
  color: red;
}

.camera-modal-content img {
  width: 100%;
  max-height: 100%;
  margin: 0 auto;
}

video {
  width: 100%;
  max-width: 100%;
  height: auto;
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>
